module.exports = __webpack_public_path__ + "assets/vantus-ico-pickdate.40a859e5.svg";